export default "__VITE_ASSET__be10a2ca__"